import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JsonapiClient from '@holidayextras/jsonapi-client';
import _ from 'lodash';
import { withRouter } from 'react-router';
import axios from 'axios';
import v from 'validator';

import { compose } from 'recompose';
import {
  Tab,
} from 'semantic-ui-react';

import ConfirmationModal from '../../components/confirmation-modal';
import AddTeamMemberForm from '../../components/add-team-member-form';

import { authService } from '../../utils/auth-service';
import { reportError } from '../../utils/error-handling-service';

import {
  ORGANISATION_RESOURCE,
} from '../../utils/helpers/resources';

import hasUserInfo from '../../hocs/has-user-info';

const REEPAY_PLANS = {
  premium: 'https://dyzio.reepay.com/e2107b19c39a4263a632f5e93010fc34',
  proteam: 'https://dyzio.reepay.com/2cddaf93f6e2b4c06d824b2eb7414217',
};


const panes = [
  { menuItem: 'Settings' },
  { menuItem: 'Team' },
  { menuItem: 'Tags' },
  { menuItem: 'Gifting Inventory' },
  { menuItem: 'Business Units' },
];

const boxStyle = {
  padding: '24px calc(50vw - 670px)',
  paddingBottom: 0,
  background: '#FFF',
};

const paneStyle = {
  marginTop: 10,
};

const routes = ['/team/manage', '/team/members', '/team/tags', '/team/inventory', '/team/business-units'];

class TeamManager extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    userInfo: PropTypes.object,
  };

  static defaultProps = {
    userInfo: null,
  };

  constructor() {
    super();
    this.state = {
      organisation: null,
      user: {
        name: '',
        email: '',
      },
      errors: {
        name: false,
        email: false,
        loading: false,
      },
      members: [],
      addingUser: false,
      loading: true,
      toBeDeleted: null,
      modalVisible: false,
      paymentModalVisible: false,
      cancelModalVisible: false,
    };

    // TODO: Move this to HOC
    this.client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    // TODO: Move this to HOC
    this.restClient = axios.create({
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }


  fetchOrganisation = () => {
    const { userInfo } = this.props;
    if (userInfo) {
      const { organisationId } = userInfo;
      this.client.get(ORGANISATION_RESOURCE, organisationId).then(organisationResource => {
        const organisation = organisationResource.toJSON();
        return this.setState({ organisation }, this.fetchTeamMembers);
      })
        .catch(err => {
          reportError('Unknown error', err);
        });
    }
  }
  componentDidMount = () => {
    this.fetchOrganisation();
  }

  fetchTeamMembers = () => {
    const { organisation, errors } = this.state;
    errors.loading = false;
    this.setState({
      loading: true,
      errors,
    });
    this.client.find('users', { filter: { organisation: organisation.id }, sort: ['name'], 'page[limit]': 500 })
      .then(users => {
        const userJsons = _.map(users, u => u.toJSON());
        return this.setState({
          members: userJsons,
          loading: false,
        });
      })
      .catch(err => {
        reportError('FETCH_TEAM_MEMBER_ERROR', err);
        errors.loading = true;
        this.setState({
          errors,
          loading: false,
        });
      }); // TODO: handle errors
  };

  handleDeleteConfirmation = (e, data) => {
    const toBeDeleted = {
      id: data.id,
      name: data.name,
    };
    this.setState({
      toBeDeleted,
    });
  }

  handleDeleteCancel = () => this.setState({
    toBeDeleted: null,
  });

  handleAddUser = async () => {
    const { user, organisation, members } = this.state;

    let updatedMembers = members;

    try {
      const users = await this.client.find('users', { filter: { organisation: organisation.id }, sort: ['name'], 'page[limit]': 500 });
      const userJsons = _.map(users, u => u.toJSON());
      updatedMembers = userJsons;
      this.setState({
        members: updatedMembers,
      });
    } catch (err) {
      reportError('FETCH_TEAM_MEMBER_ERROR', err);
    }

    const creatingUser = this.props.userInfo;

    const errors = {
      name: v.isEmpty(user.name) ? 'Name is required.' : false,
      email: v.isEmpty(user.email) || !v.isEmail(user.email) ? 'Email should be an valid email address.' : false,
    };

    if (user.name && _.split(_.trim(user.name), /\s+/).length < 2) {
      errors.name = 'Enter both your first and last name.';
    }

    if (user.email && _.find(updatedMembers, member => _.toLower(member.email) === _.toLower(user.email))) {
      errors.email = `'${user.email}' is already on your team.`;
    }

    if (errors.name || errors.email) {
      this.setState({
        errors,
      });
      return;
    }

    this.setState({
      addingUser: true,
    });

    const { origin } = window.location;
    const resource = this.client.create('users');
    resource.set('name', user.name);
    resource.set('email', user.email);
    resource.set('origin', origin);
    resource.set('organisation', {
      type: 'organisations',
      id: organisation.id,
    });
    resource.set('createdBy', creatingUser.name);
    resource.set('createdDate', new Date());
    resource.set('createdByProcess', 'TEAM_MANAGER');
    resource.sync()
      .then(res => {
        const newUser = res.toJSON();
        updatedMembers.push(newUser);
        const patch = {
          data: {
            type: 'organisations',
            attributes: {
              users: _.map(updatedMembers, f => ({ type: 'users', id: f.id })),
            },
          },
        };
        const cb = () => this.setState({
          members: updatedMembers,
          modalVisible: false,
          user: {
            name: '',
            email: '',
          },
          addingUser: false,
        });
        return this.patchOrganisation(organisation.id, patch, cb);
      })
      .catch(err => {
        reportError('ADD_USER_ERROR', err);
      });
  }

  patchOrganisation = (id, patch, cb) =>
    this.restClient.patch(process.env.REACT_APP_API_BASE_URL.concat(`/organisations/${id}`), patch).then(cb)

  handleTeamMemberDelete = () => {
    const { toBeDeleted, members, organisation } = this.state;
    const url = process.env.REACT_APP_API_BASE_URL.concat(`/users/${toBeDeleted.id}`);
    this.restClient.delete(url)
      .then(() => {
        const patched = _.reject(members, ['id', toBeDeleted.id]);
        const patch = {
          data: {
            type: 'organisations',
            attributes: {
              users: _.map(patched, f => ({ type: 'users', id: f.id })),
            },
          },
        };
        return this.patchOrganisation(organisation.id, patch, () => {
          this.setState({
            toBeDeleted: null,
            members: patched,
            loading: false,
          });
        });
      }).catch(err => {
        reportError('DELETE_USER_ERROR', err);
      });
  }

  toggleAddMemberPopup = () => {
    this.setState({
      modalVisible: !this.state.modalVisible,
      errors: {
        name: false,
        email: false,
      },
      addingUser: false,
    });
  }

  togglePaymentModal = () => {
    this.setState({
      paymentModalVisible: !this.state.paymentModalVisible,
    });
  }

  toggleCancelModal = () => {
    this.setState({
      cancelModalVisible: !this.state.cancelModalVisible,
    });
  }

  handleFormChange = (e, field) => {
    if (field && field.name) {
      const { user } = this.state;
      user[field.name] = field.name === 'email' ? _.toLower(field.value) : field.value;
      this.setState({ user });
    }
  }

  handleOrganisationChange = (e, { name, value }) => {
    const {
      organisation,
    } = this.state;
    this.setState({
      organisation: {
        ...organisation,
        [name]: value,
      },
    }, () => {
      this.patchOrganisationSettings();
    });
  }

  patchOrganisationSettings = () => {
    const {
      organisation: {
        defaultCurrency,
        usesGlobalTags = false,
      },
    } = this.state;
    const { userInfo: { organisationId } } = this.props;
    const patch = {
      data: {
        attributes: {
          defaultCurrency,
          usesGlobalTags,
        },
      },
    };
    this.patchOrganisation(organisationId, patch);
  }

  handlePaymentSuccess = licenseInfo => {
    this.togglePaymentModal();
    const { organisation } = this.state;
    organisation.licenseInfo = licenseInfo;

    this.setState({
      organisation,
    });
  }

  openReepayWindow = plan => {
    const planUrl = REEPAY_PLANS[plan];
    window.open(planUrl, '_blank');
  };

  render() {
    const {
      loading,
      addingUser,
      organisation,
      toBeDeleted,
      modalVisible,
      user,
      errors,
    } = this.state;

    const {
      children,
    } = this.props;

    if (loading) {
      return (
        <div className="page">
          <div className="page-content">
            <h1 style={{ padding: 100 }}>loading...</h1>
          </div>
        </div>
      );
    }


    const onTabChanged = (event, data) => {
      const { activeIndex } = data;
      const { history } = this.props;
      history.push(routes[activeIndex]);
    };

    const pathname = _.get(this.props, 'location.pathname');
    const activeIndex = _.findIndex(routes, route => _.eq(route, pathname));

    return (

      <div className="page">
        {
          organisation &&
          <div style={boxStyle}>
            <h1>{ _.get(organisation, 'name') }</h1>
            <Tab activeIndex={activeIndex} panes={panes} style={paneStyle} onTabChange={onTabChanged} />
          </div>
        }
        <div className="page-content">

          {
            React.cloneElement(children, this.state, { ...{
              handleDeleteConfirmation: this.handleDeleteConfirmation,
              openAddTeamMemberModal: this.toggleAddMemberPopup,
              handleOrganisationChange: this.handleOrganisationChange,
              fetchOrganisation: this.fetchOrganisation,
            },
            ...this.props })
          }

          { !loading && toBeDeleted &&
            <ConfirmationModal
              bodyText={`Are you sure you want to delete ${toBeDeleted.name} from your team?`}
              onCancel={this.handleDeleteCancel}
              onConfirm={this.handleTeamMemberDelete}
            />
          }
          {
            modalVisible && <AddTeamMemberForm
              errors={errors}
              user={user}
              addingUser={addingUser}
              formChangeHandler={this.handleFormChange}
              addUserHandler={this.handleAddUser}
              popupToggleHandler={this.toggleAddMemberPopup}
            />
          }
        </div>

      </div>
    );
  }
}

TeamManager.propTypes = {
  userInfo: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default compose(
  hasUserInfo,
  withRouter,
)(TeamManager);



/** WEBPACK FOOTER **
 ** ./src/containers/team-manager/index.js
 **/